// extracted by mini-css-extract-plugin
module.exports = {"boxOnlyDetails":"HAM_boxOnlyDetails__B9B7t"};